var map = {
	"./123live-fullcolor.svg": 21053,
	"./123live.svg": 28819,
	"./emoji/bang.png": 9841,
	"./emoji/fingers-crossed.png": 25387,
	"./emoji/hearts.png": 48910,
	"./emoji/hello.png": 54674,
	"./favicon_123tv.png": 47257,
	"./favicon_travel.png": 35099,
	"./logo_123travel.png": 70379,
	"./logo_123travel_white.png": 55619,
	"./logo_123tv.png": 87211,
	"./shopHQ.png": 43015
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 84198;